import CategoryCreatePage from "admin/pages/CategoryPage/CategoryCreatePage/CategoryCreatePage";
import { ProductEditPageAdmin } from "admin/pages/ProductPage";
import {
  CartListPageAdmin,
  CategoryListPageAdmin,
  HomePageAdmin,
  ProductCreatePageAdmin,
  ProductListPageAdmin,
  SaleListPageAdmin,
} from "../admin/pages";
import { RouterPrivateName } from "../shared/RouterPrivateName";
export const privateRoutesName = [
  {
    key: "ADMIN_HOMEPAGE",
    path: `${RouterPrivateName.HomePage.url}`,
    exact: true,
    component: HomePageAdmin,
  },
  {
    key: "ADMIN_PRODUCT_LIST",
    path: `${RouterPrivateName.Product.List.url}`,
    exact: true,
    component: ProductListPageAdmin,
  },
  {
    key: "ADMIN_PRODUCT_CREATE",
    path: `${RouterPrivateName.Product.Create.url}`,
    exact: true,
    component: ProductCreatePageAdmin,
  },
  {
    key: "ADMIN_PRODUCT_UPDATE",
    path: `${RouterPrivateName.Product.Update.url}/:id`,
    exact: true,
    component: ProductEditPageAdmin,
  },
  {
    key: "ADMIN_CATEGORY_LIST",
    path: `${RouterPrivateName.Category.List.url}`,
    exact: true,
    component: CategoryListPageAdmin,
  },
  {
    key: "ADMIN_CATEGORY_CREATE",
    path: `${RouterPrivateName.Category.Create.url}`,
    exact: true,
    component: CategoryCreatePage,
  },
  {
    key: "ADMIN_CART_LIST",
    path: `${RouterPrivateName.Cart.List.url}`,
    exact: true,
    component: CartListPageAdmin,
  },
  {
    key: "ADMIN_SALE_LIST",
    path: `${RouterPrivateName.Sale.List.url}`,
    exact: true,
    component: SaleListPageAdmin,
  },
];
